import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { BFF_ENDPOINTS } from 'src/app/constants';
import networkService from 'src/app/lib/network-service';
import { ICheckExerciseResponseType } from 'src/types/serviceResponseTypes';
import { accessTokenAtom, checkExerciseAtom, frameParamsAtom } from './../../state/atoms';

/**
 * Network hook to check Excercise
 */
function useCheckExercise() {
  const [checkExercise, setCheckExercise] = useRecoilState(checkExerciseAtom);
  const [frameParams] = useRecoilState(frameParamsAtom);
  const [accessToken] = useRecoilState(accessTokenAtom);

  const checkExerciseRequest = useCallback(async () => {
    setCheckExercise({
      ...checkExercise,
      loading: true,
    });

    networkService
      .get<ICheckExerciseResponseType>(
        `${process.env.REACT_APP_BASE_URL ?? ''}${BFF_ENDPOINTS.CHECK_EXERCISE}`,
        {
          exercise_id: frameParams.exercise_id,
          book_code: frameParams.book_code ?? '',
        },
        {
          'X-Authorization': 'Bearer ' + accessToken,
        }
      )
      .then((response) => {
        if (response.status) {
          setCheckExercise({
            loading: false,
            data: response.data as ICheckExerciseResponseType,
            error: response.error,
          });
        } else {
          setCheckExercise({
            loading: false,
            data: {} as ICheckExerciseResponseType,
            error: response.error,
          });
        }
      });
  }, [
    accessToken,
    checkExercise,
    frameParams.book_code,
    frameParams.exercise_id,
    setCheckExercise,
  ]);

  return { checkExerciseRequest, checkExercise };
}

export default useCheckExercise;
